import { type RequestTypeEnum } from '@webapp/core/entities/internal/enums/RequestTypeEnum'

const legalEntityKey = 'legal-entity'

export const legalEntityKeys = {
  list: [legalEntityKey, 'list'] as const,
  requestable: (requestType: RequestTypeEnum) =>
    [legalEntityKey, 'requestable', requestType] as const,
}
